// Ticket 19 — small caption that sits above each MeasureBarChart so
// admins / managers understand the percentages reflect their visibility
// (not the global truth). Shared by TeamsDashboardView (Ticket 18) and
// AgentProfileView (Ticket 19).
export function CallCountCaption({ count }: { count: number }) {
  return (
    <div className="text-xs text-muted-foreground mb-2 tabular-nums">
      Based on {count.toLocaleString()} {count === 1 ? "call" : "calls"} in
      your scope
    </div>
  );
}
